<template>
  <div :class="[`n-checkbox`, disabled && 'disabled']">
    <input
      :id="`${ id }`"
      :type="`checkbox`"
      :checked="value"
      :readonly="readonly"
      :disabled="disabled"
      @change="onChange"
    >

    <label :for="id">
      <span v-html="label" />
      <slot />
    </label>
  </div>
</template>

<script>
export default {
	name: 'n-checkbox',

	props: {
		value: {
      type: Boolean,
      default: false
		},

		id: {
			type: String,
			default: ''
		},

    label: {
			type: String,
			default: ''
		},

    readonly: {
			type: Boolean,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		onChange () {
			this.$emit('input', !this.value);
		}
	}
};
</script>

<style lang="scss">
.n-checkbox.disabled {
	pointer-events: none;

	label:before {
		opacity: 0.5;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/n-checkbox.vue